import { NoSettingsPanel } from './NoSettingsPanel.js';

export function FeelingsPageSettings() {
  return (
    <NoSettingsPanel
      pageLabel="Feelings"
      description="A 24-button feelings check-in across four quadrants (calm, happy, sad, mad). The selection is per-meeting and resets at midnight."
    />
  );
}
